import React from "react";
import { QRCodeSVG } from "qrcode.react";

const generateQrCode = ({ data, size = 160 }) => {
  return <QRCodeSVG value={data} size={size} />;
};

export { generateQrCode };
